/* eslint-disable jsx-a11y/label-has-associated-control */
// Hooks
import { useSearchBoxContext } from '@/utils/hooks/context/searchBox/useSearchBoxContext';

// Types
import type { SocialProfileFormattedType } from '@/components/layouts/LayoutPlatform/components/Header/components/ManageProfiles/Popover/ProfilesTab';

// Components
import Checkbox from '@/components/base/Checkbox';
import { SocialProfileInfo } from '@/components/composite/SocialProfiles/Components/SocialProfileInfo';
import useUserRole from '@/utils/hooks/user/useUserRole';

type SocialProfileItemProps = SearchItemsProps & {
    profile: Omit<SocialProfileFormattedType, 'selected'>;
};

export function SocialProfileItem({
    profile,
    displayErrorWarning = false
}: SocialProfileItemProps) {
    const { isAdmin } = useUserRole();
    return (
        <span className="flex items-center gap-2 overflow-hidden">
            <SocialProfileInfo
                profile={profile}
                size="sm"
                isAdmin={isAdmin}
                displayErrorWarning={displayErrorWarning}
            />
        </span>
    );
}

type SearchItemsProps = {
    displayErrorWarning?: boolean;
};

export function SearchItems({ displayErrorWarning = false }: SearchItemsProps) {
    const { dataContext, dispatch } = useSearchBoxContext<SocialProfileFormattedType>();
    const { filteredData, initialData } = dataContext;
    return filteredData.map((profile) => {
        return (
            <label key={profile.id} className="flex items-center justify-between gap-3">
                <SocialProfileItem profile={profile} displayErrorWarning={displayErrorWarning} />
                <Checkbox
                    boxSize="sm"
                    id={typeof profile.id === 'number' ? profile.id.toString() : profile.id}
                    onChange={(e) =>
                        dispatch({
                            type: e.target.checked ? 'ADD_ITEM' : 'REMOVE_ITEM',
                            payload: profile
                        })
                    }
                    checked={profile.selected}
                    disabled={
                        profile.selected &&
                        initialData.filter((profile) => profile.selected).length === 1
                    }
                    data-testid={`item-${profile.id}`}
                />
            </label>
        );
    });
}
